<template>
  <layout-content-vertical-nav :nav-menu-items="navMenuItemsToRender" >
    <slot></slot>

    <!-- Slot: Navbar -->
    <template #navbar="{ isVerticalNavMenuActive, toggleVerticalNavMenuActive }">
      <div
        class="navbar-content-container"
        :class="{'expanded-search': shallShowFullSearch}"
      >
        <!-- Left Content: Search -->
        <div class="d-flex align-center">
          <v-btn
            tabindex="0"
            v-if="!isVerticalNavMenuActive"
            id="menuButton"
            icon
            @click="toggleVerticalNavMenuActive"
            aria-label="menu-toggle"
          >
            <v-icon
              class=" "
            >
              {{ icons.mdiMenu }}
            </v-icon>
          </v-btn>
        </div>

        <!-- Right Content: I18n, Light/Dark, Notification & User Dropdown -->
        <div class="d-flex align-center right-row">
          <app-bar-theme-switcher></app-bar-theme-switcher>
          <app-bar-i18n></app-bar-i18n>
          <app-bar-user-menu></app-bar-user-menu>
        </div>
      </div>
    </template>

    <!-- Slot: Footer -->
    <template #footer>
      <div class="d-flex justify-space-between">
        <span style="font-size: 16px !important;">
          &copy; {{ new Date().getFullYear() }}
          <a
            href="https://perkins.org"
            class="text-decoration-none"
          >
            Perkins Scool for the Blind
          </a>
          <span class="d-none d-md-inline">, {{$t('All rights Reserved.')}}</span>
          {{$t('Powered by')}}
          <a
            href="https://letscode.ar"
            class="text-decoration-none"
          >
            Let's Code
          </a>.
        </span>
        <div class="align-center d-none d-md-flex">
        </div>
      </div>
    </template>
  </layout-content-vertical-nav>
</template>

<script>
import LayoutContentVerticalNav from '@/@core/layouts/variants/content/vertical-nav/LayoutContentVerticalNav.vue'
import navMenuItems from '@/navigation/vertical/index-for-coordinator'
import navMenuItemsForAdmin from '@/navigation/vertical/index-for-admin'
import navMenuItemsForSuperAdmin from '@/navigation/vertical/index-for-super-admin'
import navMenuItemsForSchoolRep from '@/navigation/vertical/index-for-school-rep'

// App Bar Components
import AppBarThemeSwitcher from '@core/layouts/components/app-bar/AppBarThemeSwitcher.vue'
import AppBarSearch from '@core/layouts/components/app-bar/AppBarSearch.vue'
import AppBarUserMenu from '@/components/AppBarUserMenu.vue'
import AppBarI18n from '@core/layouts/components/app-bar/AppBarI18n.vue'

import { mdiMenu, mdiHeartOutline, mdiChevronRight } from '@mdi/js'

import { getVuetify } from '@core/utils'

// Search Data
import appBarSearchData from '@/assets/app-bar-search-data'

import { ref, watch } from '@vue/composition-api'

export default {
  components: {
    LayoutContentVerticalNav,

    // App Bar Components
    AppBarThemeSwitcher,
    AppBarSearch,
    AppBarUserMenu,
    AppBarI18n,
  },

  methods: {

  },
  setup() {
    const $vuetify = getVuetify()

    // Search
    const appBarSearchQuery = ref('')
    const shallShowFullSearch = ref(false)
    const maxItemsInGroup = 5
    const totalItemsInGroup = ref({
      pages: 0,
      files: 0,
      contacts: 0,
    })
    watch(appBarSearchQuery, () => {
      totalItemsInGroup.value = {
        pages: 0,
        files: 0,
        contacts: 0,
      }
    })

    // NOTE: Update search function according to your usage
    const searchFilterFunc = (item, queryText, itemText) => {
      if (item.header || item.divider) return true

      const itemGroup = (() => {
        if (item.to !== undefined) return 'pages'
        if (item.size !== undefined) return 'files'
        if (item.email !== undefined) return 'contacts'

        return null
      })()

      const isMatched = itemText.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1

      if (isMatched) {
        if (itemGroup === 'pages') totalItemsInGroup.value.pages += 1
        else if (itemGroup === 'files') totalItemsInGroup.value.files += 1
        else if (itemGroup === 'contacts') totalItemsInGroup.value.contacts += 1
      }

      return appBarSearchQuery.value && isMatched && totalItemsInGroup.value[itemGroup] <= maxItemsInGroup
    }

    // ? Handles case where in <lg vertical nav menu is open and search is triggered using hotkey then searchbox is hidden behind vertical nav menu overlaty
    const handleShallShowFullSearchUpdate = (isVerticalNavMenuActive, toggleVerticalNavMenuActive) => {
      if ($vuetify.breakpoint.mdAndDown && isVerticalNavMenuActive) {
        toggleVerticalNavMenuActive()
      }
    }

    let navMenuItemsToRender = navMenuItems
    const session = localStorage.getItem('session') || sessionStorage.getItem('session')
    if (session) {
      const parsedSession = JSON.parse(session)
      if (parsedSession.user.role === 0 || parsedSession.user.role === 1) {
        if(parsedSession.user.role === 0) {
          navMenuItemsToRender = navMenuItemsForSuperAdmin
        } else {
          navMenuItemsToRender = navMenuItemsForAdmin
        }
      } else if (parsedSession.user.role === 3) {
        navMenuItemsToRender = navMenuItemsForSchoolRep
      }
    }

    return {
      navMenuItems,
      navMenuItemsToRender,
      handleShallShowFullSearchUpdate,

      // Search
      appBarSearchQuery,
      shallShowFullSearch,
      appBarSearchData,
      searchFilterFunc,

      icons: {
        mdiMenu,
        mdiHeartOutline,
        mdiChevronRight
      },
    }
  },
}
</script>

<style lang="scss" scoped>

.navbar-content-container {
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-grow: 1;
  position: relative;
  font-family: "AvenirNext";
}

// ? Handle bg of autocomplete for blured appBar
.v-app-bar.bg-blur {
  .expanded-search {
    ::v-deep .app-bar-autocomplete-box div[role='combobox'] {
      background-color: transparent;
    }

    > .d-flex > button.v-icon {
      display: none;
    }

    // ===

    & > .right-row {
      visibility: hidden;
      opacity: 0;
    }

    ::v-deep .app-bar-search-toggler {
      visibility: hidden;
    }
  }
}
</style>
